import { jsx } from "react/jsx-runtime";
import { Stack, styled } from "@mui/material";
const Row = styled((props) => /* @__PURE__ */ jsx(Stack, { alignItems: "center", direction: "row", ...props }))``;
export {
  Row
};
//# sourceMappingURL=Row.js.map
